import ExtendedMyAccountApi from '@api/ExtendedProfileApi'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-profile'

export function createMyAccountAPIClient (): ExtendedMyAccountApi {
  return new ExtendedMyAccountApi({ basePath })
}
